import { COVERGO_SAAS_DEV, COVERGO_SAAS_GAMMA, COVERGO_ASIA_QA, COVERGO_CA_UAT, COVERGO_ASIA_NFR } from "../consts.js"

export const humania_gamma = {
	"humania-studio.gamma.covergo.cloud": {
		appConfig: {
			tenantId: "humania_gamma",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_GAMMA,
	},
}

export const humania_dev = {
	"humania-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "humania_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
}

// The correct format should be [tenant]-[appname].[environment].[region].covergo.cloud
// but we removed the [region] part because the certificate on k8s did not have it for NFR
export const humania_nfr = {
	"humania-studio.nfr.covergo.cloud": {
		appConfig: {
			tenantId: "humania_nfr",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_NFR,
	},
}

export const humania_qa = {
	"humania-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "humania_qa",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-humania-qa"
		}
	},
}

export const humania_uat = {
	"humania-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "humania_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-humania-uat"
		}
	},
}

